const doc = [({"ko":({"adminConstantHotelMealType":({"all_meals":"아침·점심·저녁 식사", "both":"저녁·아침 식사", "breakfast":"아침 식사", "dinner":"저녁 식사", "nothing":"식사 없음"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;